module.exports = __webpack_public_path__ + "static/media/registerL.54f16259.jpg";